var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9141 35.3334C30.9141 39.2421 29.2136 42.7754 26.4974 45.1825C24.1566 47.3025 21.0649 48.5834 17.6641 48.5834C10.3545 48.5834 4.41406 42.643 4.41406 35.3334C4.41406 29.2384 8.56573 24.0709 14.1749 22.5471C15.6986 26.3896 18.967 29.3488 23.0082 30.453C24.1124 30.7621 25.2828 30.9167 26.4974 30.9167C27.712 30.9167 28.8824 30.7621 29.9866 30.453C30.5828 31.9546 30.9141 33.6109 30.9141 35.3334Z",
    stroke: "#33CCCC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 17.6667C39.75 19.3892 39.4187 21.0455 38.8225 22.5472C37.2987 26.3897 34.0304 29.3488 29.9892 30.453C28.885 30.7622 27.7146 30.9167 26.5 30.9167C25.2854 30.9167 24.115 30.7622 23.0108 30.453C18.9696 29.3488 15.7013 26.3897 14.1775 22.5472C13.5813 21.0455 13.25 19.3892 13.25 17.6667C13.25 10.3572 19.1904 4.41675 26.5 4.41675C33.8096 4.41675 39.75 10.3572 39.75 17.6667Z",
    stroke: "#33CCCC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5833 35.3334C48.5833 42.643 42.6429 48.5834 35.3333 48.5834C31.9325 48.5834 28.8408 47.3025 26.5 45.1825C29.2163 42.7754 30.9167 39.2421 30.9167 35.3334C30.9167 33.6109 30.5854 31.9546 29.9892 30.453C34.0304 29.3488 37.2988 26.3896 38.8225 22.5471C44.4317 24.0709 48.5833 29.2384 48.5833 35.3334Z",
    stroke: "#33CCCC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdIcon03);
export default __webpack_public_path__ + "static/media/sd-icon03.e6ea702c002fcef61610ff5cbf0a7a92.svg";
export { ForwardRef as ReactComponent };